import React from 'react';

const LogudIkon = () => (
	<svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M1 9.92285C1 8.81828 1.89543 7.92285 3 7.92285H14.3848C15.4893 7.92285 16.3848 8.81828 16.3848 9.92285V18.9999C16.3848 20.1045 15.4893 20.9999 14.3848 20.9999H3C1.89543 20.9999 1 20.1045 1 18.9999V9.92285Z" stroke="#92004D" strokeWidth="2" />
		<path d="M12.5361 7.15391V4.84619C12.5361 2.722 10.8141 1 8.68994 1V1C6.56575 1 4.84375 2.722 4.84375 4.84619V5.15391" stroke="#92004D" strokeWidth="2" />
	</svg>
);

export default LogudIkon;
